<ng-container *ngIf="items && items.length > 0">
  <h2 data-test="eN1gaoo5">{{ title }}</h2>
  <table data-test="CucHCueA" class="document__table items-table items-table_light">
    <tr data-test="8JwyrOs1" class="items-table__header items-table__header_fs-9">
      <th data-test="EkcLbb36">service name</th>
      <th data-test="oFzedCMX">description</th>
      <th data-test="rxpASS_G">billable price</th>
      <th data-test="BEVrnHjO">quantity</th>
      <th data-test="yoWpDwSD">amount</th>
    </tr>
    <tr data-test="UAUo7rnM" class="row-type" *ngFor="let service of items; index as i">
      <td data-test="btzTQ5At">
        <b data-test="Von-7fFm">{{ service.name }}</b>
      </td>
      <td data-test="Vjgd9WzV">{{ service.description }}</td>
      <td data-test="CYvnwu3m" class="text-right text-nowrap">
        <span data-test="CYOHJCC6" class="text-light">{{ currencySign }}</span>
        {{ service.billablePrice | fromCents | companyCurrency }}
      </td>
      <td data-test="oKCaaPPU" class="text-right text-nowrap">
        {{ service.qty }}
      </td>
      <td data-test="eMxEo6iy" class="text-right text-nowrap pr-2">
        <span data-test="3Bwt-JGV" class="text-light">{{ currencySign }}</span>
        {{ service.amount | fromCents | companyCurrency }}
      </td>
    </tr>
  </table>

  <div data-test="pTe7-T9S" class="pr-2 text-right h3">
    Total:
    <span data-test="2nhU4NjK" class="text-light">{{ currencySign }}</span>
    {{ getTotal() | fromCents | companyCurrency }}
  </div>
</ng-container>
